import { getAllEvents } from '../../action/events'

export const eventsCalendarLoader = async () => {

    const today = new Date()
    getAllEvents( today.getFullYear(), today.getMonth() )

}
